/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { mapObject, constant } from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { HelpLink } from '@bingads-webui-react/help-link';
import { getAlertStyle } from './alert-react-style';

const Alert = (props) => {
  const [visible, setVisible] = React.useState(true);
  const { i18n, alertKey, learnMoreId } = props;

  return (
    visible &&
    <div className={`alert alert-info ${props.classes.root}`} >
      <div className="alert-image" />
      <div className="alert-info-inline" >
        <span>
          {`${i18n.getString(alertKey)} `}
          <HelpLink class="HelpTopic" query={learnMoreId} aria-label={i18n.getString(alertKey)} role="button">
            {i18n.getString('LearnMoreLinkText')}
          </HelpLink>
        </span>
        <span
          className="glyphicon glyphicon-remove"
          role="button"
          onClick={() => { setVisible(false); }}
        />
      </div>
    </div>);
};

Alert.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    percentToFixedFormatter: PropTypes.func.isRequired,
    decimalFormatter: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape(mapObject(
    getAlertStyle(),
    constant(PropTypes.string.isRequired)
  )).isRequired,
  alertKey: PropTypes.string.isRequired,
  learnMoreId: PropTypes.string.isRequired,
};

export const AlertReact = withDefaultStyles(Alert, getAlertStyle);
